import { getLeadSourceFilterLabel } from '../constants/leadSourceOptions';

/**
 * CRM lead source for list/detail — always the stored lead.source field.
 * Never substitute prelead campaign names (those belong on prelead screens only).
 */
export function getLeadSourceDisplay(lead) {
  const raw = lead?.source?.trim();
  if (!raw) return '---';
  return getLeadSourceFilterLabel(raw) || raw;
}
